import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import {bindActionCreators} from "redux"
import { Row, Col, Collapse, Icon, Button, Tooltip, Card, Tag, Spin, message } from 'antd';
import { getCourse, getSections } from '../../../../core/actions/courseGet';
import { getUserAndAddCourse } from '../../../../core/actions/allUsers'
import { updatePlaylist, clearGetCourses } from '../../../../core/actions/actions';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
import CourseInfoDetails from '../../components/courseinfo/courseinfodetails'
import { Helmet } from "react-helmet";
import { getLastView } from '../../../../core/actions/courseGet';


const Panel = Collapse.Panel;

class CourseInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      course: {},
      sections: [],
      toggleAction: false
    };
    this.showModal = this.showModal.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentWillMount() {
    window.scrollTo({ top: 0 });
    const { slug } = this.props.match.params;
    this.props.getCourse(slug);
    this.props.getSections(slug);
    if(this.props.auth.uid){
      this.props.getLastView(this.props.auth.uid)
    }
  }

  componentDidMount() {
    this.checkHours()
    // eslint-disable-next-line no-undef

  }

  checkHours = (num) => {
    let hours = Math.floor(num / 3600);
    return hours
  }

  componentWillReceiveProps(nextProps) {
    const { course, sections,courseGetSuccessful, auth, coursePageError } = nextProps;
    if(coursePageError) {
      this.props.history.push('/error')
    }
    if (course) this.setState({ course });
    if (courseGetSuccessful) {
      sections.sort((a, b) => a.position > b.position ? 1 : -1)
      sections.map((sect) => {
        sect.lectures.sort((a, b) => a.position > b.position ? 1 : -1)
      })
      this.setState({ sections })
      this.props.clearGetCourses()
      
    }
  
    // if (!auth.uid) this.context.router.push('/');
  }

  showModal(data) {
    const { auth } = this.props
    const { section, activeLecture } = data;
    if (!auth.uid) {
      message.info('You need to be logged in!');
      this.toggleModal()
    } else {
      this.props.updatePlaylist(section.lectures[activeLecture])
      this.props.history.push(`/courses/${this.props.match.params.slug}/lectures`)
      // this.setState({ visible: true, lectures: section.lectures, activeSection: section.id, activeLecture });
    }
  }

  toggleModal = () => this.setState({
    toggleAction: !this.state.toggleAction
  })

  handleCancel() {
    this.setState({ visible: false });
  }

  checkHours = (num) => {
    let hours = Math.floor(num / 3600);
    return hours
  }

  render() {
    var { profile } = this.props
    const { course, sections, toggleAction } = this.state;
    const loading = !sections.length > 0;
    const courseCollapseHeader = item => (
      <div className="title">
        <span className="lecture-mtitle">{item.title}</span>
        <span className="lecture-duration">
          {
            this.checkHours(item.duration) ? moment.utc(item.duration * 1000).format('hh:mm:ss') : moment.utc(item.duration * 1000).format('mm:ss')
          }
        </span>
        <span className="lectures">{item.lectures.length <= 1 ? `${item.lectures.length} lecture` : `${item.lectures.length} lectures`}</span>
      </div>
    );
    return (
      !loading ? <div className="xcourse-info">
        <Helmet>
          <title>{this.props.match.params.slug.replace(/[-]/gi, " ")}</title>
          <meta name="description" content={"Ready to get started? orsity has many free community resource courses for you to start learning today. Create your free account and choose something to learn."} />
        </Helmet>

        <TopNav history={this.props.history} />

        {/* <Banner /> */}

        <CourseInfoDetails
          course={course}
          firebase={this.props.firebase}
          auth={this.props.auth}
          match={this.props.match}
          history={this.props.history}
          updatePlaylist={this.props.updatePlaylist}
          section={sections}
          getUserAndAddCourse={this.props.getUserAndAddCourse}
          lastViewCourse={this.props.lastViewCourse}
        />

        <Footer />

      </div> : <div className="x-loader">
          <Icon type="loading" style={{ fontSize: 60 }} spin />
        </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.firebase.auth,
  firebase: state.firebase,
  activeLecture: state.playlistReducer.activeLecture,
  profile: state.firebase.profile,
  course: state.getCourses.course,
  lastViewCourse: state.getCourses.lastViewCourse,
  sections: state.getCourses.sections,
  coursePageError: state.getCourses.coursePageError,
  courseGetSuccessful: state.getCourses.courseGetSuccessful
});
const mapDispatchToProps = dispatch => bindActionCreators({
  getSections,
  getCourse,
  updatePlaylist,
  getUserAndAddCourse,
  getLastView,
  clearGetCourses
},dispatch)

// const mapDispatchToProps = dispatch => ({
//   getSections: courseId => dispatch(getSections(courseId)),
//   getCourse: courseId => dispatch(getCourse(courseId)),
//   updatePlaylist: activeLecture => dispatch(updatePlaylist(activeLecture)),
//   getUserAndAddCourse: courseId => dispatch(getUserAndAddCourse(courseId)),
//   getLastView: 
// });

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseInfo);
